module.exports = __webpack_public_path__ + "img/date_input.8f6ce902.svg";